var __jsx = React.createElement;
import MusclePlatformLayout from '@modules/layout';
import ErrorScreen from '@modules/shared/screen-templates/error-screen';
import React from 'react';
const MuscleErrorPage = _ref => {
  let {
    code,
    addButton,
    title,
    subtitle,
    message,
    buttonText,
    onClickButton,
    storyblokImageKey
  } = _ref;
  return __jsx(MusclePlatformLayout, {
    showCustomerSupport: true
  }, __jsx(ErrorScreen, {
    code: code,
    addButton: addButton,
    title: title,
    subtitle: subtitle,
    message: message,
    buttonText: buttonText,
    onClickButton: onClickButton,
    storyblokImageKey: storyblokImageKey
  }));
};
export default MuscleErrorPage;